import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { getP } from 'redux-polyglot'
import * as Actions from 'store/actions'
import { State } from 'store/reducers/index.types'
import { getIsNavigationRedirectionButtonFeatureEnabled } from 'store/selectors'
import { MapDispatchToProps, MapStateToProps } from './types'

const mapStateToProps = (state: State): MapStateToProps => ({
  disabled: !getIsNavigationRedirectionButtonFeatureEnabled(state),
  p: getP(state)
})

const mapDispatchToProps = (dispatch: Dispatch): MapDispatchToProps => ({
  onRedirectToNavigation: () => dispatch(Actions.navigation.onRedirectToNavigation()),
  onSearchButtonClick: () => dispatch(Actions.navigation.onSearchButtonClick())
})

export default connect(mapStateToProps, mapDispatchToProps)
